import _ from 'lodash';
import statuses from 'dictionaries/RequestStatuses';

export default _.pick(statuses, [1, 8, 17]);



// WEBPACK FOOTER //
// ./src/containers/request/RequestList/statusOptions.js